import Decimal from 'decimal.js'
import { NextRouter } from 'next/router'

export const styling = {
  itemSize: 66,
  itemGap: 4,
  itemPerView: 6,
}

export const listHeight = new Decimal(styling.itemSize)
  .plus(styling.itemGap)
  .times(styling.itemPerView)
  .minus(styling.itemGap)

export const calculateItemPositionTop = (index: number) => {
  return new Decimal(index)
    .times(styling.itemSize + styling.itemGap)
    .minus(index ? styling.itemGap : 0)
    .toNumber()
}

export const clickAndOpenInNewTab = (url: string) => {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  a.click()
}

export const handleClickHighlightMessage = (url: string, router: NextRouter) => {
  try {
    if (url.startsWith('/')) {
      router.push(url)
    }

    if (/^(http|https):\/\//.test(url)) {
      const urlObj = new URL(url)
      const isSameSite = urlObj.origin === window.location.origin

      if (isSameSite) {
        router.push(urlObj.pathname)
      } else {
        clickAndOpenInNewTab(url)
      }
    }
  } catch (err) {
    //
  }
}
